.mission {
  margin-top: 52px;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 18px;
  box-shadow: var(--plume-shadow-card, 6px 6px 0 var(--color-primary-grey-900));
  padding: 48px 52px;
  overflow: hidden;
}

.mission__quote {
  margin: 0;
}

.mission__quote p {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 700;
  font-size: clamp(21px, 2.5vw, 30px);
  line-height: 1.3;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0;
}

.mission__manifesto {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 22px;
  font-weight: 700;
  font-size: 15px;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.mission__manifesto:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 2px;
}

@media (max-width: 560px) {
  .mission {
    padding: 32px 28px;
  }
}
